import React from "react";
import { StyledButton } from "./styled";

function Button({ className, children, type, isActive, size, ...props }) {
  return (
    <StyledButton
      className={className}
      type={type}
      isActive={isActive}
      size={size}
      {...props}
    >
      {children}
    </StyledButton>
  );
}

export default Button;
